import { render, staticRenderFns } from "./DrawableObject.vue?vue&type=template&id=3eac3b30&scoped=true&"
import script from "./DrawableObject.vue?vue&type=script&lang=ts&"
export * from "./DrawableObject.vue?vue&type=script&lang=ts&"
import style0 from "./DrawableObject.vue?vue&type=style&index=0&id=3eac3b30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eac3b30",
  null
  
)

export default component.exports